(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["df-lander-bohrloecher"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initLander() {
    var root = document.querySelector('.df-lp');
    if (!root || root.dataset.llInit === '1') return;
    root.dataset.llInit = '1';

    // Review slider
    var track = root.querySelector('#rv0tk');
    var dots = root.querySelectorAll('.slider-dot');
    var prevBtn = root.querySelector('#rv0pv');
    var nextBtn = root.querySelector('#rv0nx');
    if (!track) return;
    var current = 0;
    var total = root.querySelectorAll('.review-slide').length || 1;
    var autoplay;

    function goTo(index) {
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
      current = index;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function (d, i) { d.classList.toggle('active', i === current); });
    }
    function startAutoplay() {
      autoplay = setInterval(function () { goTo(current + 1); }, 5000);
    }
    function resetAutoplay() { clearInterval(autoplay); startAutoplay(); }

    if (prevBtn) prevBtn.addEventListener('click', function (e) { e.preventDefault(); goTo(current - 1); resetAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function (e) { e.preventDefault(); goTo(current + 1); resetAutoplay(); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { goTo(parseInt(dot.dataset.slide, 10)); resetAutoplay(); });
    });

    var startX = 0;
    track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) { diff > 0 ? goTo(current + 1) : goTo(current - 1); resetAutoplay(); }
    }, { passive: true });

    startAutoplay();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLander);
  } else {
    initLander();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["info-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  var roots = document.querySelectorAll('.info-bar');
  roots.forEach(function (root) {
    var slider = root.querySelector('[data-slider]');
    var nextBtn = root.querySelector('[data-slider-next]');
    var prevBtn = root.querySelector('[data-slider-prev]');
    if (!slider || slider.children.length === 0) return;

    var slides = slider.children;
    var index = 0;
    var slideInterval = null;
    var mobileMql = window.matchMedia('(max-width: 767px)');
    var reducedMotionMql = window.matchMedia('(prefers-reduced-motion: reduce)');

    function updateSlider() {
      slider.style.transform = 'translateX(-' + (index * 100) + '%)';
    }
    function nextSlide() { index = (index + 1) % slides.length; updateSlider(); }
    function prevSlide() { index = (index - 1 + slides.length) % slides.length; updateSlider(); }

    function startAutoSlide() {
      stopAutoSlide();
      if (reducedMotionMql.matches) return;
      slideInterval = setInterval(nextSlide, 3000);
    }
    function stopAutoSlide() {
      if (slideInterval) { clearInterval(slideInterval); slideInterval = null; }
    }

    nextBtn && nextBtn.addEventListener('click', function () { nextSlide(); startAutoSlide(); });
    prevBtn && prevBtn.addEventListener('click', function () { prevSlide(); startAutoSlide(); });

    root.addEventListener('mouseenter', stopAutoSlide);
    root.addEventListener('mouseleave', function () { if (mobileMql.matches) startAutoSlide(); });
    root.addEventListener('focusin', stopAutoSlide);
    root.addEventListener('focusout', function () { if (mobileMql.matches) startAutoSlide(); });

    function activate() { index = 0; updateSlider(); startAutoSlide(); }
    function deactivate() { stopAutoSlide(); index = 0; slider.style.transform = ''; }

    function syncState(e) { e.matches ? activate() : deactivate(); }
    syncState(mobileMql);

    var listener = function (e) { syncState(e); };
    if (mobileMql.addEventListener) mobileMql.addEventListener('change', listener);
    else if (mobileMql.addListener) mobileMql.addListener(listener);

    var rmListener = function () { startAutoSlide(); };
    if (reducedMotionMql.addEventListener) reducedMotionMql.addEventListener('change', rmListener);
    else if (reducedMotionMql.addListener) reducedMotionMql.addListener(rmListener);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
